import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../modules/bulkFormula';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {

	/** @namespace state.lists.bulkFormulaIds **/
	/** @namespace state.maps.bulkFormula */
	let bulkFormulas = [];
	if (state.lists.bulkFormulaIds) {
		bulkFormulas = _.map(state.lists.bulkFormulaIds, id => state.maps.bulkFormula[id]);
	}

	return {
		bulkFormulas,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchBulkFormulas : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
